/* eslint-disable react/no-unknown-property */
import React, { useEffect, useMemo, useRef, useState } from "react"
import { useLocation } from "react-router-dom"
import Breadcrumbs from "components/Common/Breadcrumb"
import {
    Row,
    Col,
    Card,
    CardBody,
    Form,
    Label,
    Input,
    Button,
    Container,
    FormFeedback,
    Modal,
    ModalHeader,
    ModalBody,
    UncontrolledTooltip,
    Table,
} from "reactstrap"
import { prepareDataForValidation, useFormik } from "formik"
import * as Yup from "yup"
import { useNavigate } from "react-router-dom"

import toast, { Toaster } from "react-hot-toast"
import useApi from "common/ApiMiddlewere"
import Select from "react-select";
import jsPDF from "jspdf"
import { font } from "pages/Reports/Booking/font"
import { InvoiceHtml } from "pages/Reports/Booking/invoicePDF"
import breadcrumbs from "common/Breadcrumbs"
import { routes } from "routes/path"
import TableList from "components/Common/TableList"
import { dateFormat } from "pages/Common"
import SaleBreadcrumb from "components/Common/SaleBreadcrumb"
import TableListSales from "../Sales/TableListSales"
import GetObjectsByValues from "_mock/Static_data"

const colourStyles = {
    option: (styles, { isDisabled, isFocused }) => {
        return {
            ...styles,
            backgroundColor: isFocused ? "#556ee6" : "#f8f9fa",
            color: isFocused ? "#fff" : "#495057",
            cursor: isDisabled ? "not-allowed" : "default",
            padding: "3px 10px",
        }
    },
    control: (styles, { isDisabled }) => {
        const updatedStyles = {
            ...styles,
            border: "1px solid  #ced4da",
            cursor: isDisabled ? "not-allowed" : "default",
            backgroundColor: isDisabled ? "#e8e9ebd1" : "default",
            minHeight: "28px",
            padding: "3px 10px",
            fontSize: "12px",
        }
        return updatedStyles
    },
}

const colourStyles1 = {
    option: (styles, { isDisabled, isFocused }) => {
        return {
            ...styles,
            backgroundColor: isFocused ? "#556ee6" : "#f8f9fa",
            color: isFocused ? "#fff" : "#495057",
            cursor: isDisabled ? "not-allowed" : "default",
            padding: "3px 10px",
        }
    },
    control: (styles, { isDisabled }) => {
        const updatedStyles = {
            ...styles,
            border: "1px solid #f46a6a",
            minHeight: "28px",
            padding: "3px 10px",
            fontSize: "12px",
        }
        return updatedStyles
    },
}

let discount = 0
function CreatePurchase() {
    document.title = `Purchase | ${localStorage.getItem("ShopName")}`
    const { getApi, postApi, putApi } = useApi()
    const nextInputRef = useRef(null);
    let { pathname } = useLocation()
    const { state } = useLocation()
    const [isEdit, setIsEdit] = useState(false)
    const navigate = useNavigate()
    const [screeLoad, setscreeLoad] = useState(false)
    const [paymentMethod, setpaymentMethod] = useState("1")
    const [items, setItems] = useState([])
    const [purchaseId, setPurchaseId] = useState(0)
    const [isDiscountCalculate, setIsDiscountCalculate] = useState(false)
    const [totalCGSTAmount, setTotalCGSTAmount] = useState(0)
    const [totalSGSTAmount, setTotalSGSTAmount] = useState(0)
    const [totalIGSTAmount, setTotalIGSTAmount] = useState(0)
    const [totalAmt, setTotalAmt] = useState(0)
    const [totalNetAmt, setTotalNetAmt] = useState(0.00)
    const [totalTexes, setTotalTexes] = useState(0)
    const [totalQty, setTotalQty] = useState(0.00)
    const [isDelete, setIsDelete] = useState(false)
    const [itemName, setItemName] = useState(null)
    const [selectedItem, setSelectedItem] = useState({})
    const [isError, setIsError] = useState(false)
    const [isItemEdit, setIsItemEdit] = useState(false)
    const [editItem, setEditItem] = useState(0)
    const [editProductCode, seteditProductCode] = useState()
    const [itemStock, setItemStock] = useState("0")
    const [billNo, setBillNo] = useState(0)
    const [oldItemIdOrCode, setOldItemIdOrCode] = useState('')
    const [purchaseAccounts, setPurchaseAccounts] = useState([])
    const [vendorAccounts, setVendorAccounts] = useState([])

    // table state management
    const [tableData, setTableData] = useState([])
    useEffect(() => {
        if (state?.purchaseId) {
            setscreeLoad(true)
            getApi(`Purchases/details?id=${state?.purchaseId}`).then(({ data, status }) => {
                setIsEdit(true)
                if (status === 200) {
                    setBillNo(data?.PurchaseDetails?.BillNo)
                    validation.setFieldValue("date", new Date(new Date(data?.PurchaseDetails?.Date).setDate(new Date(data?.PurchaseDetails?.Date).getDate() + 1)).toISOString().slice(0, 10),)
                    validation.setFieldValue("PurchaseAccountId", data?.PurchaseDetails?.PurchaseAccountId)
                    validation.setFieldValue("VendorAccountId", data?.PurchaseDetails?.VendorAccountId
                    )
                    validation.setFieldValue("remark", data?.PurchaseDetails?.Remarks)
                    validation.setFieldValue("discount", data?.PurchaseDetails?.Discount)
                    discount = data?.PurchaseDetails?.Discount;
                    setPurchaseId(data?.PurchaseDetails?.Id)
                    setTotalCGSTAmount(data?.PurchaseDetails?.CGSTAmount)
                    setTotalSGSTAmount(data?.PurchaseDetails?.SGSTAmount)
                    setTotalIGSTAmount(data?.PurchaseDetails?.IGSTAmount)
                    setpaymentMethod(data?.PurchaseDetails?.PaymentMode == 2 ? "2" : "1");
                    setTotalAmt(data?.PurchaseDetails?.TotalAmount)
                    // setTotalAmt(data?.PurchaseDetails?.TaxableAmount)
                    setTotalNetAmt(data?.PurchaseDetails?.NetAmount)
                    setTotalTexes(data?.PurchaseDetails?.CGSTAmount + data?.PurchaseDetails?.SGSTAmount + data?.PurchaseDetails?.IGSTAmount)
                    setTotalQty(data?.PurchaseDetails?.TotalQty)
                    data?.PurchaseItemsList.forEach(function (item, index) {
                        item["editItem"] = index + 1
                        setEditItem(index + 1)
                    })
                    setTableData(data?.PurchaseItemsList)
                } else {
                    toast.error(data, {
                        style: {
                            fontSize: "15px",
                        },
                    });
                }
                setscreeLoad(false)
            })
        }
    }, [state])

    useEffect(() => {
        setscreeLoad(true)
        getApi(`Accounts/accounts-lookup?accountGroup=${GetObjectsByValues(4)[0].Value}`).then(({ data, status }) => {
            if (status === 200) {
                setVendorAccounts(data)
            } else {
                toast.error(data, {
                    style: {
                        fontSize: "15px",
                    },
                })
            }
            setscreeLoad(false)
        })
        getApi(`Accounts/accounts-lookup?accountGroup=${GetObjectsByValues(5)[0].Value}`).then(({ data, status }) => {
            if (status === 200) {
                setPurchaseAccounts(data)
            } else {
                toast.error(data, {
                    style: {
                        fontSize: "15px",
                    },
                })
            }
            setscreeLoad(false)
        })

        getApi("Items/items-lookup").then(({ data, status }) => {
            if (status === 200) {
                const itemData = data.map(item => ({
                    label: `${item.ItemCode} - ${item.Name}`,
                    value: item.ItemCode,
                    Id: item.Id,
                    ItemCode: item.ItemCode,
                    Name: item.Name,
                    BarCodeNo: item.BarcodeNo,
                    CGST: item.CGST,
                    SGST: item.SGST,
                    IGST: item.IGST,
                    MRP: item.MRP,
                    OpeningStock: item.OpeningStock,
                    Qty: item.Qty,
                }));
                itemData.unshift({
                    label: "Select",
                    value: "",
                    id: 0,
                    ItemCode: '',
                    Name: '',
                    BarCodeNo: '',
                    CGST: 0,
                    SGST: 0,
                    IGST: 0,
                    MRP: 0,
                    OpeningStock: 0,
                    Qty: 0,
                });
                setItems(itemData)
            } else {
                toast.error(data, {
                    style: {
                        fontSize: "15px",
                    },
                })
            }
            setscreeLoad(false)
        })
        discount = validation.values.discount || 0

    }, [])

    // Booking Validations
    const validation = useFormik({
        enableReinitialize: false,
        initialValues: {
            remark: "",
            discount: '',
            date: new Date().toISOString().slice(0, 10),
            VendorAccountId: 0,
            PurchaseAccountId: 0,
        },
        validationSchema: Yup.object({
            date: Yup.string().required("The date is required"),
            VendorAccountId: Yup.number().min(1, "The vendor account is required"),
            PurchaseAccountId: Yup.number().min(1, "The purchase account is required"),

        }),

        onSubmit: values => {
            if (tableData.length > 0) {
                setscreeLoad(true)
                tableData.forEach(function (item) {
                    item.TotalAmount = parseFloat(item.TotalAmount)
                    item.CGSTPer = parseFloat(item.CGSTPer) || 0
                    item.SGSTPer = parseFloat(item.SGSTPer) || 0
                    item.IGSTPer = parseFloat(item.IGSTPer) || 0
                    item.Price = item.Price ? parseFloat(item.Price) : 0 || 0
                    item.TotalPrice = parseFloat(item.TotalPrice) || 0
                });

                const Api = isEdit ? putApi : postApi;
                const endPoint = isEdit ? 'Purchases/update' : 'Purchases/create'
                const successMessage = isEdit ? "Update successfully" : "Purchase successfully"
                const obj = {
                    Id: purchaseId,
                    date: values.date,
                    vendorAccountId: parseInt(values.VendorAccountId),
                    purchaseAccountId: parseInt(values.PurchaseAccountId),
                    totalAmount: parseFloat(totalAmt),
                    // TaxableAmount: parseFloat(totalAmt),
                    discount: discount,
                    paymentMode: parseFloat(paymentMethod),
                    termsDays: 0,
                    totalQty: totalQty,
                    CGSTAmount: parseFloat(totalCGSTAmount),
                    SGSTAmount: parseFloat(totalSGSTAmount),
                    IGSTAmount: parseFloat(totalIGSTAmount),
                    netAmount: parseFloat(totalNetAmt),
                    remarks: values.remark || "",
                    purchaseItems: tableData,
                }
                Api(endPoint, obj).then(({ data, status }) => {
                    if (status === 200) {
                        navigate(routes.purchaseList)
                        toast.success(successMessage, {
                            style: {
                                fontSize: "15px",
                            },
                        })
                    } else {
                        toast.error(data, {
                            style: {
                                fontSize: "15px",
                            },
                        })
                    }
                    setscreeLoad(false)
                })
            } else {
                toast.error("Atleast one Item add in table", {
                    style: {
                        fontSize: "15px",
                    },
                })
            }
        },
    })

    // allow only number key
    const handleKeyPress = event => {
        const charCode = event.which || event.keyCode;
        if ((charCode < 48 || charCode > 57) && charCode != 46) {
            event.preventDefault();
        }
    };

    // Delete Each Product Booking handler
    const deleteHandle = (Id) => {
        let updatedArray = []
        updatedArray = tableData
            .map(obj => (obj.ItemId !== Id ? obj : null))
            .filter(Boolean)
        setTableData(updatedArray)
        setIsDelete(true)
        handleTotalGstAmounts(updatedArray, discount)
    }
    // Edit Each Product Booking handler
    const editHandle = (data) => {
        seteditProductCode(data)
        setOldItemIdOrCode(data.ItemId);
        setIsItemEdit(true)
        setSelectedItem({
            Id: data.ItemId,
            Name: data.ItemName,
            ItemCode: data.ItemCode
        })
        const filterdata = items.filter(item => item.Id == data.ItemId)
        setItemName(filterdata)
        setItemStock(filterdata[0]?.Qty || 0)
        setFieldValue(data)
    }

    // table  existing product validation
    const exitInBookingItem = (arr, obj) => {
        for (let i = 0; i < arr.length; i++) {
            const item = arr[i]
            if ((item.ItemId == parseInt(obj.ItemId)) && (parseInt(obj.ItemId) != parseInt(oldItemIdOrCode))) {
                return true
            }
        }
        return false
    }

    // Product Detilas validation
    const productDetailsValidation = useFormik({
        enableReinitialize: true,
        // initialValues
        initialValues: {
            Id: 0,
            ItemId: 0,
            ItemCode: "",
            ItemName: "",
            Qty: '1',
            Price: 0,
            CGSTPer: 0,
            SGSTPer: 0,
            IGSTPer: 0,
            TaxableAmount: 0,
            TotalPrice: 0,
            TotalAmount: 0,
            CGSTAmount: 0,
            SGSTAmount: 0,
            IGSTAmount: 0,
            editItem: editItem,
            itemStock: 0,
            // remarks: "",
        },

        // input validation
        validationSchema: Yup.object().shape({
            Qty: Yup.number().min(1, "The qty is required"),
        }),

        onSubmit: (purchaseItem) => {
            // select control validation
            if ((Object.keys(selectedItem).length === 0) || (selectedItem?.label == "Select")
            ) {
                setIsError(true);
                return;
            }
            // CGSTPer & SGSTPer validation
            if (productDetailsValidation.values.CGSTPer > 0 && productDetailsValidation.values.SGSTPer == 0 || productDetailsValidation.values.SGSTPer > 100) {
                return false;
            }
            if (productDetailsValidation.values.SGSTPer > 0 && productDetailsValidation.values.CGSTPer == 0 || productDetailsValidation.values.CGSTPer > 100) {
                return false;
            }

            // product add & edit
            handleNonProductEdit(purchaseItem);
        },
    })

    function setFieldValue(purchaseItem) {
        productDetailsValidation.setFieldValue("Qty", purchaseItem.Qty)
        productDetailsValidation.setFieldValue("Price", purchaseItem.Price)
        productDetailsValidation.setFieldValue("CGSTPer", purchaseItem.CGSTPer)
        productDetailsValidation.setFieldValue("SGSTPer", purchaseItem.SGSTPer)
        productDetailsValidation.setFieldValue("IGSTPer", purchaseItem.IGSTPer)
        productDetailsValidation.setFieldValue("TotalPrice", purchaseItem.TotalPrice)
        productDetailsValidation.setFieldValue("TotalAmount", purchaseItem.TotalAmount)
        productDetailsValidation.setFieldValue("ItemCode", purchaseItem?.ItemCode)
    }

    // in table product add & edit function
    function handleNonProductEdit(purchaseItem) {
        purchaseItem.ItemId = selectedItem?.Id;
        // in table existing product & item validation
        const existingItem = exitInBookingItem(tableData, purchaseItem);
        if (!existingItem) {
            if (!isItemEdit) {
                setEditItem(editItem + 1)
            }
            // All GST amount  calculation
            purchaseItem.editItem = isItemEdit ? editProductCode.editItem : editItem;
            purchaseItem.CGSTAmount = (purchaseItem.Price * purchaseItem.CGSTPer * purchaseItem.Qty) / 100;
            purchaseItem.SGSTAmount = (purchaseItem.Price * purchaseItem.SGSTPer * purchaseItem.Qty) / 100;
            purchaseItem.IGSTAmount = (purchaseItem.Price * purchaseItem.IGSTPer * purchaseItem.Qty) / 100;
            purchaseItem.TaxableAmount = purchaseItem.Price * purchaseItem.Qty;

            setIsError(false);
            productAddEdit(purchaseItem);
        } else {
            toast.error("Item is already listed", {
                style: {
                    fontSize: "15px",
                },
            });
        }
    }

    // product & item add edit
    function productAddEdit(purchaseItem) {
        if (isItemEdit) {
            // product & item edit
            tableData.forEach(function (item) {
                if (item.editItem === editProductCode.editItem) {
                    item.ItemCode = selectedItem?.ItemCode;
                    item.ItemId = selectedItem?.Id;
                    item.ItemName = selectedItem?.Name;
                    item.Qty = purchaseItem.Qty;
                    item.Price = purchaseItem.Price;
                    item.CGSTPer = purchaseItem.CGSTPer;
                    item.SGSTPer = purchaseItem.SGSTPer;
                    item.IGSTPer = purchaseItem.IGSTPer;
                    item.TotalPrice = purchaseItem.TotalPrice;
                    item.TotalAmount = purchaseItem.TotalAmount;
                    item.CGSTAmount = (purchaseItem.Price * purchaseItem.CGSTPer) / 100;
                    item.SGSTAmount = (purchaseItem.Price * purchaseItem.SGSTPer) / 100;
                    item.IGSTAmount = (purchaseItem.Price * purchaseItem.IGSTPer) / 100;
                    item.TaxableAmount = purchaseItem.Price * purchaseItem.Qty;
                    item.itemStock = itemStock;
                }
            });
            // GST amount calculation
            setIsItemEdit(false)
            setItemStock(0)
            handleTotalGstAmounts(tableData, discount);
            productDetailsValidation.handleReset();
        } else {
            // item add in table
            purchaseItem.ItemId = selectedItem?.Id;
            purchaseItem.ItemName = selectedItem?.Name;
            purchaseItem.ItemCode = selectedItem?.ItemCode;
            purchaseItem.itemStock = itemStock;
            const productData = [...tableData, purchaseItem];
            handleTotalGstAmounts(productData, discount);
            setTableData(productData);
            productDetailsValidation.handleReset();
        }
        setItemName('');
        setItemStock(0)
    }

    // prices calculation
    const handleNetPrice = (Price, cgst, sgst, igst, Qty) => {
        const TotalPrice = parseFloat(Price || 0) + (parseFloat(Price || 0) * (parseFloat(cgst || 0) + parseFloat(sgst || 0) + parseFloat(igst || 0)) / 100)
        const TotalAmount = TotalPrice * parseFloat(Qty || 1)
        productDetailsValidation.setFieldValue("TotalPrice", TotalPrice.toFixed(2))
        productDetailsValidation.setFieldValue("Price", Price ? Price : '')
        productDetailsValidation.setFieldValue("Qty", Qty ? Qty : '')
        productDetailsValidation.setFieldValue("TotalAmount", parseFloat(TotalAmount).toFixed(2))
        productDetailsValidation.setFieldValue("IGSTPer", igst ? igst : '')
        productDetailsValidation.setFieldValue("CGSTPer", cgst ? cgst : '')
        productDetailsValidation.setFieldValue("SGSTPer", sgst ? sgst : '')
    }

    // set GST per
    const handleGSTPer = (cgst, sgst, igst) => {
        productDetailsValidation.setFieldValue("SGSTPer", sgst ? sgst : '')
        productDetailsValidation.setFieldValue("CGSTPer", cgst ? cgst : '')
        if (parseFloat(cgst) > 0 || parseFloat(sgst) > 0) {
            productDetailsValidation.setFieldValue("IGSTPer", '')
        } else {
            productDetailsValidation.setFieldValue("IGSTPer", igst ? igst : '')
            productDetailsValidation.setFieldValue("CGSTPer", cgst ? cgst : '')
            productDetailsValidation.setFieldValue("SGSTPer", sgst ? sgst : '')
        }
        const TotalPrice = parseFloat(productDetailsValidation.values.Price || 0) + (parseFloat(productDetailsValidation.values.Price || 0) * (parseFloat(cgst || 0) + parseFloat(sgst || 0) + parseFloat(igst || 0)) / 100)
        const TotalAmount = TotalPrice * parseFloat(productDetailsValidation.values.Qty || 1)
        productDetailsValidation.setFieldValue("TotalPrice", TotalPrice.toFixed(2))
        productDetailsValidation.setFieldValue("TotalAmount", parseFloat(TotalAmount).toFixed(2))
    }

    // set GST per
    const handleIGSTPer = (cgst, sgst, igst) => {
        productDetailsValidation.setFieldValue("IGSTPer", igst ? igst : '')
        if (parseFloat(igst) > 0) {
            productDetailsValidation.setFieldValue("CGSTPer", '')
            productDetailsValidation.setFieldValue("SGSTPer", '')
        }
        else {
            productDetailsValidation.setFieldValue("IGSTPer", igst ? igst : '')
            productDetailsValidation.setFieldValue("CGSTPer", cgst ? cgst : '')
            productDetailsValidation.setFieldValue("SGSTPer", sgst ? sgst : '')
        }
        const TotalPrice = parseFloat(productDetailsValidation.values.Price || 0) + (parseFloat(productDetailsValidation.values.Price || 0) * (parseFloat(cgst || 0) + parseFloat(sgst || 0) + parseFloat(igst || 0)) / 100)
        const TotalAmount = TotalPrice * parseFloat(productDetailsValidation.values.Qty || 1)
        productDetailsValidation.setFieldValue("TotalPrice", TotalPrice.toFixed(2))
        productDetailsValidation.setFieldValue("TotalAmount", parseFloat(TotalAmount).toFixed(2))
    }

    // Net price  reverse calculation
    const handleReversenetPrice = (netPrice, cgst, sgst, igst, Qty) => {
        productDetailsValidation.setFieldValue("TotalPrice", netPrice ? netPrice : '')
        if (parseFloat(igst) > 0) {
            const itemIGSTAmount = (netPrice * 100) / (100 + parseFloat(igst || 0));
            const TotalAmount = netPrice * parseFloat(Qty || 1)
            productDetailsValidation.setFieldValue("Price", itemIGSTAmount.toFixed(2))
            productDetailsValidation.setFieldValue("TotalAmount", TotalAmount)
        }
        else {
            const totalGstPer = parseFloat(cgst || 0) + parseFloat(sgst || 0);

            //Find Total GST Amount.-
            const totalGstAmount = (netPrice * 100) / (100 + totalGstPer);
            const TotalAmount = netPrice * parseFloat(Qty || 1)
            productDetailsValidation.setFieldValue("Price", totalGstAmount.toFixed(2))
            productDetailsValidation.setFieldValue("TotalAmount", TotalAmount)

        }

    }

    // item select control automatically fills  all input
    const autoSelect = (Item, name) => {
        setItemName(Item);
        setIsError(false)
        if (name == "Item") {
            setItemStock(Item?.Qty || 0)
            setSelectedItem(Item)
            nextInputRef.current.focus();
            nextInputRef.current.select();
            handleNetPrice(Item?.MRP, Item?.CGST, Item?.SGST, Item?.IGST, 1)
        }
    }

    const handleTypeBarcode = (value) => {
        const filterdata = items.filter(item => item?.BarCodeNo?.toUpperCase() === value?.toUpperCase())
        setItemName(filterdata[0])
        if (filterdata.length > 0) {
            nextInputRef.current.focus();
            nextInputRef.current.select();
        }
        setItemStock(filterdata[0]?.Qty || 0)
        handleNetPrice(filterdata[0]?.MRP, filterdata[0]?.CGST, filterdata[0]?.SGST, filterdata[0]?.IGST, 1)
    }

    // total GST amounts calculation
    const handleTotalGstAmounts = (data, discount) => {
        const totalCGSTAmount = data
            ? data.reduce((sum, item) => sum + parseFloat(item.CGSTAmount), 0)
            : tableData.reduce((sum, item) => sum + parseFloat(item.CGSTAmount), 0)
        setTotalCGSTAmount(totalCGSTAmount.toFixed(2))

        const totalSGSTAmount = data
            ? data.reduce((sum, item) => sum + parseFloat(item.SGSTAmount), 0)
            : tableData.reduce((sum, item) => sum + parseFloat(item.SGSTAmount), 0)
        setTotalSGSTAmount(totalSGSTAmount.toFixed(2))

        const totalIGSTAmount = data
            ? data.reduce((sum, item) => sum + parseFloat(item.IGSTAmount), 0)
            : tableData.reduce((sum, item) => sum + parseFloat(item.IGSTAmount), 0)
        setTotalIGSTAmount(totalIGSTAmount.toFixed(2))

        const totoalTaxes = data
            ? data.reduce((sum, item) => sum + (parseFloat(item.IGSTAmount * item.Qty) + parseFloat(item.SGSTAmount * item.Qty) + parseFloat(item.CGSTAmount * item.Qty)), 0)
            : tableData.reduce((sum, item) => sum + (parseFloat(item.IGSTAmount * item.Qty) + parseFloat(item.SGSTAmount * item.Qty) + parseFloat(item.CGSTAmount * item.Qty)), 0)
        setTotalTexes((totalCGSTAmount + totalSGSTAmount + totalIGSTAmount).toFixed(2))

        const totalQty = data
            ? data.reduce((sum, item) => sum + parseFloat(item.Qty), 0)
            : tableData.reduce((sum, item) => sum + parseFloat(item.Qty), 0)
        setTotalQty(totalQty)

        const totalAmt = data
            ? data.reduce((sum, item) => sum + parseFloat(item.Price * item.Qty), 0)
            : tableData.reduce((sum, item) => sum + parseFloat(item.Price * item.Qty), 0)
        // setTotalNetAmt((totalAmt + totalCGSTAmount + totalSGSTAmount + totalIGSTAmount - discount))
        setTotalAmt(totalAmt)

        const totalNetAmount = data
            ? data.reduce((sum, item) => sum + parseFloat(item.TotalAmount), 0)
            : tableData.reduce((sum, item) => sum + parseFloat(item.TotalAmount), 0)
        setTotalNetAmt((totalNetAmount - discount).toFixed(2))
    }

    // discount  calculation
    const handleDisount = (value) => {
        const discountPercentage = parseFloat(value);
        validation.setFieldValue("discount", value ? value : '');
        if (isDiscountCalculate && !isNaN(discountPercentage)) {
            discount = ((parseFloat(totalAmt) + parseFloat(totalCGSTAmount) + parseFloat(totalSGSTAmount) + parseFloat(totalIGSTAmount)) * discountPercentage) / 100;
            handleTotalGstAmounts(tableData, discount);
        } else {
            discount = value ? value : 0
            handleTotalGstAmounts(tableData, discount)
        }
    }

    // discount change event function call
    useEffect(() => {
        handleDisount(validation.values.discount || 0)
    }, [isDiscountCalculate, isDelete])

    // multiple Booking Table
    const columns = useMemo(
        () => [
            {
                // Header: "Code",
                Header: () => (
                    <div
                        style={{
                            display: "flex",
                            alignItems: "start",
                        }}
                    >
                        {"Code"}
                    </div>
                ),
                accessor: "ItemCode",
                width: "10%",
                Cell: ({ row }) => {
                    return (
                        <div style={{
                            display: "flex",
                            alignItems: "start",
                        }}>
                            {row.original?.ItemCode}
                        </div>
                    )
                },
            },
            {
                Header: () => (
                    <div
                        style={{
                            display: "flex",
                            alignItems: "start",
                        }}
                    >
                        {"Item Name"}
                    </div>
                ),
                accessor: "ItemName",
                Cell: ({ row }) => {
                    return <div style={{
                        display: "flex",
                        alignItems: "start",
                    }}>{row.original?.ItemName}</div>
                },
            },
            {
                Header: "Qty",
                accessor: "Qty",
                width: "5%",
                Cell: ({ row }) => {
                    return (
                        <div style={{ textAlign: "center" }}>
                            {row.original?.Qty}
                        </div>
                    )
                },
            },
            {
                Header: () => (
                    <div style={{
                        display: "flex",
                        alignItems: "end",
                        justifyContent: "end",
                        textAlign: "end"
                    }}>
                        Price
                    </div>
                ),
                accessor: "Price",
                width: "10%",
                Cell: ({ row }) => {
                    return (
                        <div style={{
                            display: "flex",
                            alignItems: "end",
                            justifyContent: "end",
                            textAlign: "end"
                        }}>
                            <i className="mdi mdi-currency-inr"></i>
                            {new Intl.NumberFormat('en-IN', {
                                currency: 'INR',
                                minimumFractionDigits: 2,
                            }).format(row.original?.Price || 0)}
                        </div>
                    )
                },
            },
            {
                Header: () => (
                    <div style={{
                        display: "flex",
                        alignItems: "end",
                        justifyContent: "end",
                        textAlign: "end"
                    }}>
                        Net Price
                    </div>
                ),
                accessor: "TotalPrice",
                width: "10%",
                Cell: ({ row }) => {
                    return (
                        <div style={{
                            display: "flex",
                            alignItems: "end",
                            justifyContent: "end",
                            textAlign: "end"
                        }}>
                            <i className="mdi mdi-currency-inr"></i>
                            {new Intl.NumberFormat('en-IN', {
                                currency: 'INR',
                                minimumFractionDigits: 2,
                            }).format(row.original?.TotalPrice || 0)}
                        </div>
                    )
                },
            },
            {
                Header: () => (
                    <div style={{
                        display: "flex",
                        alignItems: "end",
                        justifyContent: "end",
                        textAlign: "end"
                    }}>
                        Taxable Amt.
                    </div>
                ),
                accessor: "Price,Qty",
                width: "10%",
                Cell: ({ row }) => {
                    return (
                        <div style={{
                            display: "flex",
                            alignItems: "end",
                            justifyContent: "end",
                            textAlign: "end"
                        }}>
                            <i className="mdi mdi-currency-inr"></i>
                            {new Intl.NumberFormat('en-IN', {
                                currency: 'INR',
                                minimumFractionDigits: 2,
                            }).format((row.original?.Price * row.original.Qty) || 0)}
                        </div>
                    )
                },
            },
            {
                // Header: "CGST",
                Header: () => (
                    <div style={{
                        display: "flex",
                        alignItems: "end",
                        justifyContent: "end",
                        textAlign: "end"
                    }}>
                        CGST
                    </div>
                ),
                accessor: "CGSTPer",
                width: "5%",
                Cell: ({ row }) => {
                    return (
                        <div style={{
                            display: "flex",
                            alignItems: "end",
                            justifyContent: "end",
                            textAlign: "end"
                        }}>
                            {row.original.CGSTPer ? row.original.CGSTPer : "0"}% | {new Intl.NumberFormat('en-IN', {
                                currency: 'INR',
                                minimumFractionDigits: 2,
                            }).format(row.original.CGSTAmount || 0)
                            }
                        </div>
                    )
                },
            },
            {
                Header: () => (
                    <div style={{
                        display: "flex",
                        alignItems: "end",
                        justifyContent: "end",
                        textAlign: "end"
                    }}>
                        SGST
                    </div>
                ),
                accessor: "SGSTPer",
                width: "5%",
                Cell: ({ row }) => {
                    return (
                        <div style={{
                            display: "flex",
                            alignItems: "end",
                            justifyContent: "end",
                            textAlign: "end"
                        }}>
                            {row.original.SGSTPer ? row.original.SGSTPer : "0"}% | {new Intl.NumberFormat('en-IN', {
                                currency: 'INR',
                                minimumFractionDigits: 2,
                            }).format(row.original.SGSTAmount || 0)
                            }
                        </div>
                    )
                },
            },
            {
                Header: () => (
                    <div style={{
                        display: "flex",
                        alignItems: "end",
                        justifyContent: "end",
                        textAlign: "end"
                    }}>
                        IGST
                    </div>
                ),
                accessor: "IGSTPer",
                width: "5%",
                Cell: ({ row }) => {
                    return (
                        <div style={{
                            display: "flex",
                            alignItems: "end",
                            justifyContent: "end",
                            textAlign: "end"
                        }}>
                            {row.original.IGSTPer ? row.original.IGSTPer : "0"}% | {new Intl.NumberFormat('en-IN', {
                                currency: 'INR',
                                minimumFractionDigits: 2,
                            }).format(row.original.IGSTAmount || 0)
                            }
                        </div>
                    )
                },
            },

            {
                Header: () => (
                    <div style={{
                        display: "flex",
                        alignItems: "end",
                        justifyContent: "end",
                        textAlign: "end"
                    }}>
                        Total Amt.
                    </div>
                ),
                accessor: "TotalAmount",
                width: "10%",
                Cell: ({ row }) => {
                    return (
                        <div style={{
                            display: "flex",
                            alignItems: "end",
                            justifyContent: "end",
                            textAlign: "end"
                        }}>
                            <i className="mdi mdi-currency-inr"></i>
                            {new Intl.NumberFormat('en-IN', {
                                currency: 'INR',
                                minimumFractionDigits: 2,
                            }).format(row.original?.TotalAmount || 0)}
                        </div>
                    )
                },
            },

            {
                Header: () => (
                    <div
                        style={{
                            textAlign: "center",
                        }}
                    >
                        Action
                    </div>
                ),
                width: "6%",
                accessor: "action",
                Cell: ({ row }) => {
                    return (
                        <ul className="list-unstyled hstack gap-2 mb-0 d-flex justify-content-center">
                            <li className="mytooltip">
                                <i
                                    className=" fs-6 fas fa-edit btn-edit "
                                    id={`edittooltip${row.original.Id}`}
                                    onClick={() => editHandle(row.original)}
                                ></i>
                                <span className="mytext">Edit</span>
                            </li>
                            <li className="mytooltip">
                                <i
                                    className="fs-6 fas fa-trash-alt btn-delete"
                                    id={`deletetooltip${row.original.ItemId}`}
                                    onClick={() =>
                                        deleteHandle(row.original.ItemId)
                                    }
                                ></i>
                                <span className="mytext">Delete</span>
                            </li>
                        </ul>
                    )
                },
            },
        ],
        [tableData]
    )

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid={true}>
                    {screeLoad && (
                        <div className="loading-overlay is-active">
                            <span className="fas fa-spinner fa-3x fa-spin"></span>
                        </div>
                    )}
                    <SaleBreadcrumb
                        parent={breadcrumbs[pathname].parent}
                        breadcrumbItem={breadcrumbs[pathname].breadcrumbItem}
                        parentLink={breadcrumbs[pathname].parentLink}
                        BillNo={billNo}
                        isEdit={isEdit}
                    />
                    <Row>
                        <Col md="12">
                            <Card>
                                <CardBody>
                                    <Form
                                        className="needs-validation"
                                        // onSubmit={e => {
                                        //     e.preventDefault()
                                        //     validation.handleSubmit()
                                        //     return false
                                        // }}
                                        onReset={e => {
                                            e.preventDefault
                                            validation.handleReset()
                                            return false
                                        }}
                                    >
                                        <Row>
                                            <Label className="mb-3">
                                                Customer Details
                                                <hr
                                                    style={{
                                                        background: "#00000036",
                                                        height: "0.5px",
                                                        margin: "0px",
                                                        marginBottom: "10px",
                                                    }}
                                                />
                                            </Label>
                                        </Row>

                                        <Row>
                                            <Col md={3} className="pe-0">
                                                <div className="mb-2">
                                                    <Label
                                                        htmlFor="productDetailsValidationCustom01"
                                                        className="required"
                                                    >
                                                        Date
                                                    </Label>
                                                    <Input
                                                        name="date"
                                                        placeholder="date placeholder"
                                                        type="date"
                                                        // min={new date().toISOString().slice(0, 10)}
                                                        className="form-control-sm"
                                                        onChange={validation.handleChange}
                                                        onBlur={validation.handleBlur}
                                                        value={
                                                            validation.values.date}
                                                        invalid={
                                                            validation.touched
                                                                .date &&
                                                                validation.errors.date
                                                                ? true
                                                                : false
                                                        }
                                                    />
                                                    {validation.touched.date &&
                                                        validation.errors.date ? (
                                                        <FormFeedback type="invalid">
                                                            {validation.errors.date}
                                                        </FormFeedback>
                                                    ) : null}
                                                </div>
                                            </Col>
                                            <Col md={3}>
                                                <label
                                                    htmlFor="name"
                                                    className="required form-label"
                                                >
                                                    Vendor Account
                                                </label>
                                                <Input
                                                    type="select"
                                                    id="validationCustom02"
                                                    // disabled={isEdit}
                                                    bsSize="sm"
                                                    className="form-control-sm"
                                                    name="VendorAccountId"
                                                    onChange={validation.handleChange}
                                                    onBlur={validation.handleBlur}
                                                    value={validation.values.VendorAccountId}
                                                    invalid={
                                                        validation.touched.VendorAccountId &&
                                                            validation.errors.VendorAccountId
                                                            ? true
                                                            : false
                                                    }
                                                >
                                                    <option value={0}>Select...</option>
                                                    {vendorAccounts.map((item, index) => {
                                                        return (
                                                            <option key={index} value={item.Id}>
                                                                {item.Name}
                                                            </option>
                                                        )
                                                    })}
                                                </Input>
                                                {validation.touched.VendorAccountId &&
                                                    validation.errors.VendorAccountId ? (
                                                    <FormFeedback type="invalid">
                                                        {validation.errors.VendorAccountId}
                                                    </FormFeedback>
                                                ) : null}
                                            </Col>
                                            <Col md={3}>
                                                <label
                                                    htmlFor="name"
                                                    className="required form-label"
                                                >
                                                    Purchase Account
                                                </label>
                                                <Input
                                                    type="select"
                                                    id="validationCustom02"
                                                    // disabled={isEdit}
                                                    bsSize="sm"
                                                    className="form-control-sm"
                                                    name="PurchaseAccountId"
                                                    onChange={validation.handleChange}
                                                    onBlur={validation.handleBlur}
                                                    value={validation.values.PurchaseAccountId}
                                                    invalid={
                                                        validation.touched.PurchaseAccountId &&
                                                            validation.errors.PurchaseAccountId
                                                            ? true
                                                            : false
                                                    }
                                                >
                                                    <option value={0}>Select...</option>
                                                    {purchaseAccounts.map((item, index) => {
                                                        return (
                                                            <option key={index} value={item.Id}>
                                                                {item.Name}
                                                            </option>
                                                        )
                                                    })}
                                                </Input>
                                                {validation.touched.PurchaseAccountId &&
                                                    validation.errors.PurchaseAccountId ? (
                                                    <FormFeedback type="invalid">
                                                        {validation.errors.PurchaseAccountId}
                                                    </FormFeedback>
                                                ) : null}
                                            </Col>
                                        </Row>

                                        <Row className="mb-2">
                                            <Label className="my-3">
                                                Items
                                                <hr
                                                    style={{
                                                        background: "#00000036",
                                                        height: "0.5px",
                                                        margin: "0px",
                                                        // marginBottom: "2px",
                                                    }}
                                                />
                                            </Label>
                                        </Row>

                                        <Row className="mb-2">
                                            <Col md="12">
                                                <Row>
                                                    <Col md={1} lg="2" style={{ marginTop: "2px" }}>
                                                        <span className="d-flex" style={{ justifyContent: "space-between" }}>
                                                            <label
                                                                style={{ marginBottom: "0px" }}
                                                                htmlFor="name"
                                                                className="required"
                                                            >
                                                                Items
                                                            </label>
                                                            <label style={{ marginBottom: "0px", color: itemStock >= 0 ? "green" : "red" }}>
                                                                {new Intl.NumberFormat('en-IN', {
                                                                    currency: 'INR',
                                                                }).format(itemStock)}
                                                            </label>
                                                        </span>
                                                        <Select
                                                            unstyled
                                                            styles={isError ? colourStyles1 : colourStyles}
                                                            value={itemName}
                                                            // onChange={(e) => {
                                                            //     handleSelectGroup(e);
                                                            // }}
                                                            onChange={e => {
                                                                autoSelect(e, "Item")
                                                                // handleTypeBarcode(e)
                                                            }}
                                                            onKeyDown={e => {
                                                                if (e.key === 'Enter') {
                                                                    handleTypeBarcode(e.target.value)
                                                                }
                                                            }}
                                                            options={items}
                                                            className="select2-selection "
                                                        />
                                                        {isError ? (
                                                            <div className="name-required">
                                                                {"The item is required"}
                                                            </div>
                                                        ) : null}

                                                    </Col>
                                                    <Col md={1} style={{ paddingLeft: "0" }}>
                                                        <div>
                                                            <Label className="form-label required">
                                                                Qty
                                                            </Label>
                                                            <Input
                                                                innerRef={nextInputRef}
                                                                id="qty"
                                                                name="Qty"
                                                                className="form-control-sm"
                                                                placeholder="0"
                                                                type="text"
                                                                onChange={e => handleNetPrice(productDetailsValidation.values.Price, productDetailsValidation.values.CGSTPer, productDetailsValidation.values.SGSTPer, productDetailsValidation.values.IGSTPer, e.target.value)}
                                                                // onChange={productDetailsValidation.handleChange}
                                                                onBlur={productDetailsValidation.handleBlur}
                                                                onKeyPress={handleKeyPress}
                                                                value={productDetailsValidation.values.Qty}
                                                                invalid={
                                                                    (productDetailsValidation.touched
                                                                        .Qty &&
                                                                        productDetailsValidation.errors.Qty) || productDetailsValidation.values.Qty == 0
                                                                        ? true
                                                                        : false
                                                                }
                                                            />
                                                            {(productDetailsValidation.touched.Qty &&
                                                                productDetailsValidation.errors.Qty) || productDetailsValidation.values.Qty == 0 ? (
                                                                <FormFeedback type="invalid">
                                                                    {productDetailsValidation.errors.Qty}
                                                                </FormFeedback>
                                                            ) : null}
                                                        </div>
                                                    </Col>
                                                    <Col md={1} style={{ paddingLeft: "0" }}>
                                                        <div >
                                                            <Label className="form-label">
                                                                Price
                                                            </Label>
                                                            <Input
                                                                name="Price"
                                                                className="form-control-sm"
                                                                placeholder="0.00"
                                                                type="text"
                                                                onChange={e => handleNetPrice(e.target.value, productDetailsValidation.values.CGSTPer, productDetailsValidation.values.SGSTPer, productDetailsValidation.values.IGSTPer, productDetailsValidation.values.Qty)}
                                                                // onChange={productDetailsValidation.handleChange}
                                                                onBlur={productDetailsValidation.handleBlur}
                                                                onKeyPress={handleKeyPress}
                                                                // defaultValue={productDetailsValidation.values.Price}
                                                                value={productDetailsValidation.values.Price || ''}
                                                                invalid={
                                                                    productDetailsValidation.touched.Price &&
                                                                        productDetailsValidation.errors.Price
                                                                        ? true
                                                                        : false
                                                                }
                                                            />
                                                            {productDetailsValidation.touched.Price &&
                                                                productDetailsValidation.errors.Price ? (
                                                                <FormFeedback type="invalid">
                                                                    {productDetailsValidation.errors.Price}
                                                                </FormFeedback>
                                                            ) : null}
                                                        </div>
                                                    </Col>
                                                    <Col md={1} style={{ paddingLeft: "0" }}>
                                                        <div >
                                                            <Label className="form-label">
                                                                CGST(%)
                                                            </Label>
                                                            <Input
                                                                name="CGSTPer"
                                                                className="form-control-sm"
                                                                placeholder="0.00"
                                                                type="text"
                                                                onChange={e => {
                                                                    let inputValue = e.target.value;
                                                                    if (isNaN(inputValue)) {
                                                                        inputValue = 0;
                                                                    } else if (inputValue < 0) {
                                                                        inputValue = 0;
                                                                    }

                                                                    handleGSTPer(
                                                                        // productDetailsValidation.values.Price,
                                                                        inputValue,
                                                                        productDetailsValidation.values.SGSTPer,
                                                                        productDetailsValidation.values.IGSTPer,
                                                                        // productDetailsValidation.values.Qty
                                                                    );
                                                                }}
                                                                onBlur={productDetailsValidation.handleBlur}
                                                                onKeyPress={handleKeyPress}
                                                                value={productDetailsValidation.values.CGSTPer}
                                                                invalid={
                                                                    productDetailsValidation.values.SGSTPer > 0 && productDetailsValidation.values.CGSTPer == 0 || productDetailsValidation.values.CGSTPer > 100 ? true : false
                                                                }
                                                            />
                                                            {productDetailsValidation.values.SGSTPer > 0 && productDetailsValidation.values.CGSTPer == 0 || productDetailsValidation.values.CGSTPer > 100 ? (
                                                                <FormFeedback type="invalid">
                                                                    {"CGSTPer required"}
                                                                </FormFeedback>
                                                            ) : null}
                                                        </div>
                                                    </Col>
                                                    <Col md={1} style={{ paddingLeft: "0" }}>
                                                        <div >
                                                            <Label className="form-label">
                                                                SGST(%)
                                                            </Label>
                                                            <Input
                                                                name="SGSTPer"
                                                                className="form-control-sm"
                                                                placeholder="0.00"
                                                                type="text"
                                                                onChange={e => {
                                                                    let inputValue = e.target.value;
                                                                    if (isNaN(inputValue)) {
                                                                        inputValue = 0;
                                                                    } else if (inputValue < 0) {
                                                                        inputValue = 0;
                                                                    }
                                                                    handleGSTPer(
                                                                        // productDetailsValidation.values.Price,
                                                                        productDetailsValidation.values.CGSTPer,
                                                                        inputValue,
                                                                        productDetailsValidation.values.IGSTPer,
                                                                        // productDetailsValidation.values.Qty
                                                                    );
                                                                }}
                                                                onBlur={productDetailsValidation.handleBlur}
                                                                onKeyPress={handleKeyPress}
                                                                value={productDetailsValidation.values.SGSTPer}
                                                                invalid={
                                                                    productDetailsValidation.values.CGSTPer > 0 && productDetailsValidation.values.SGSTPer == 0 || productDetailsValidation.values.SGSTPer > 100 ? true : false
                                                                }
                                                            />
                                                            {productDetailsValidation.values.CGSTPer > 0 && productDetailsValidation.values.SGSTPer == 0 || productDetailsValidation.values.SGSTPer > 100 ? (
                                                                <FormFeedback type="invalid">
                                                                    {"SGSTPer required"}
                                                                </FormFeedback>
                                                            ) : null}
                                                        </div>
                                                    </Col>
                                                    <Col md={1} style={{ paddingLeft: "0" }}>
                                                        <div >
                                                            <Label className="form-label">
                                                                IGST(%)
                                                            </Label>
                                                            <Input
                                                                name="IGSTPer"
                                                                className="form-control-sm"
                                                                placeholder="0.00"
                                                                type="text"
                                                                onChange={e => {
                                                                    let inputValue = e.target.value;
                                                                    if (isNaN(inputValue)) {
                                                                        inputValue = 0;
                                                                    } else if (inputValue < 0) {
                                                                        inputValue = 0;
                                                                    }
                                                                    handleIGSTPer(
                                                                        // productDetailsValidation.values.Price,
                                                                        productDetailsValidation.values.CGSTPer,
                                                                        productDetailsValidation.values.SGSTPer,
                                                                        inputValue,
                                                                        // productDetailsValidation.values.Qty
                                                                    )
                                                                }}
                                                                onBlur={productDetailsValidation.handleBlur}
                                                                onKeyPress={handleKeyPress}
                                                                value={productDetailsValidation.values.IGSTPer}
                                                                invalid={
                                                                    (productDetailsValidation.values.CGSTPer == 0 && productDetailsValidation.values.SGSTPer == 0 ? false : false) || (productDetailsValidation.values.IGSTPer > 100 ? true : false)
                                                                }
                                                            />
                                                            {(productDetailsValidation.values.CGSTPer == 0 && productDetailsValidation.values.SGSTPer == 0) || (productDetailsValidation.values.IGSTPer > 100) ? (
                                                                <FormFeedback type="invalid">
                                                                    {productDetailsValidation.errors.IGSTPer}
                                                                </FormFeedback>
                                                            ) : null}

                                                        </div>
                                                    </Col>
                                                    <Col md={2} style={{ paddingLeft: "0" }}>
                                                        <div >
                                                            <Label className="form-label">
                                                                Net Price
                                                            </Label>
                                                            <Input
                                                                name="TotalPrice"
                                                                className="form-control-sm"
                                                                placeholder="0.00"
                                                                type="text"
                                                                onChange={e => {
                                                                    let inputValue = e.target.value;
                                                                    if (isNaN(inputValue)) {
                                                                        inputValue = '';
                                                                    } else if (inputValue < 0) {
                                                                        inputValue = '';
                                                                    }

                                                                    handleReversenetPrice(
                                                                        inputValue,
                                                                        productDetailsValidation.values.CGSTPer,
                                                                        productDetailsValidation.values.SGSTPer,
                                                                        productDetailsValidation.values.IGSTPer,
                                                                        productDetailsValidation.values.Qty
                                                                    )
                                                                }}
                                                                onBlur={productDetailsValidation.handleBlur}
                                                                onKeyPress={handleKeyPress}
                                                                value={productDetailsValidation.values.TotalPrice}

                                                            />



                                                        </div>
                                                    </Col>
                                                    <Col md={2} style={{ paddingLeft: "0" }}>
                                                        <div >
                                                            <Label className="form-label">
                                                                Total Amt.
                                                            </Label>
                                                            <Input
                                                                name="TotalAmount"
                                                                disabled
                                                                className="form-control-sm"
                                                                placeholder="0.00"
                                                                type="text"
                                                                onChange={productDetailsValidation.handleChange}
                                                                onBlur={productDetailsValidation.handleBlur}
                                                                onKeyPress={handleKeyPress}
                                                                value={productDetailsValidation.values.TotalAmount}
                                                                invalid={
                                                                    productDetailsValidation.touched.TotalAmount &&
                                                                        productDetailsValidation.errors.TotalAmount
                                                                        ? true
                                                                        : false
                                                                }
                                                            />
                                                            {productDetailsValidation.touched.TotalAmount &&
                                                                productDetailsValidation.errors.TotalAmount ? (
                                                                <FormFeedback type="invalid">
                                                                    {productDetailsValidation.errors.TotalAmount}
                                                                </FormFeedback>
                                                            ) : null}
                                                        </div>
                                                    </Col>
                                                    <Col md={1} className="text-sm-end">
                                                        <Button
                                                            color="primary"
                                                            className="btn btn-success btn-sm "
                                                            type="button"
                                                            onClick={e => {
                                                                e.preventDefault()
                                                                productDetailsValidation.handleSubmit()
                                                                return false
                                                            }}
                                                            style={{ marginTop: "21px", padding: "4px 14px" }}
                                                        >
                                                            Add
                                                        </Button>
                                                    </Col>
                                                </Row>
                                            </Col>
                                        </Row>
                                        <Row className="mt-3">
                                            <Col md="12" className="text-end ">
                                                <TableListSales
                                                    columns={columns}
                                                    data={tableData}
                                                    isGlobalFilter={false}
                                                    isCreateBooking={false}
                                                    customPageSize={10}
                                                    className="custom-header-css"
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mt-3">
                                            <Col md={4}>
                                                <Row>
                                                    <Col md={12} className="">
                                                        <div className="">
                                                            <Label htmlFor="validationCustom05">Remark</Label>
                                                            <Input
                                                                name="remark"
                                                                rows="3"
                                                                placeholder="Type your remark here"
                                                                type="textarea"
                                                                className="form-control-sm"
                                                                value={validation.values.remark || ""}
                                                                onChange={validation.handleChange}
                                                                onBlur={validation.handleBlur}
                                                            />
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </Col>
                                            <Col md={8} style={{ display: "flex", justifyContent: "end" }}>
                                                <Row>
                                                    <Col md={3} >
                                                        <Row>
                                                            <Col md={12} style={{ marginTop: "7px" }}>
                                                                <Label htmlFor="validationCustom05">Discount</Label>
                                                            </Col>
                                                            <Col md={12}>
                                                                <Label htmlFor="validationCustom03"> <div className=" d-flex gap-2">
                                                                    <input
                                                                        type="radio"
                                                                        value={false}
                                                                        id="flat"
                                                                        className="form-check-input"
                                                                        style={{ fontSize: "12px" }}
                                                                        checked={isDiscountCalculate == false}
                                                                        onClick={() => { setIsDiscountCalculate(false), handleDisount(0) }}
                                                                    />
                                                                    <Label className="form-check-label font-size-12" style={{ marginRight: "7px" }} htmlFor="flat">
                                                                        Flat
                                                                    </Label>

                                                                    <input
                                                                        type="radio"
                                                                        value={true}
                                                                        id="per"
                                                                        className="form-check-input"
                                                                        checked={isDiscountCalculate == true}
                                                                        style={{ fontSize: "12px" }}
                                                                        onClick={() => { setIsDiscountCalculate(true), handleDisount(0) }}
                                                                    />
                                                                    <Label className="form-check-label font-size-12" htmlFor="per">
                                                                        Per.(%)
                                                                    </Label>
                                                                </div></Label>
                                                                <div>
                                                                    <Input
                                                                        name="discount"
                                                                        placeholder="0.00"
                                                                        type="text"
                                                                        className="form-control-sm"
                                                                        // onChange={validation.handleChange}
                                                                        onKeyPress={handleKeyPress}
                                                                        onChange={e => {
                                                                            let inputValue = e.target.value;
                                                                            if (isNaN(inputValue)) {
                                                                                inputValue = 0;
                                                                            } else if (inputValue < 0) {
                                                                                inputValue = 0;
                                                                            }
                                                                            handleDisount(inputValue)
                                                                        }}
                                                                        onBlur={validation.handleBlur}
                                                                        value={validation.values.discount}
                                                                        // onFocus={(e) => { e.target.select() }}
                                                                        invalid={isDiscountCalculate &&
                                                                            validation.values.discount > 100 ? true : false
                                                                        }
                                                                    />
                                                                    {isDiscountCalculate && validation.values.discount > 100 ? (
                                                                        <FormFeedback type="invalid">
                                                                            {validation.errors.discount}
                                                                        </FormFeedback>
                                                                    ) : null}
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                    </Col>
                                                    <Col md={4} style={{ fontSize: "14px", marginTop: "5px", textAlign: "-webkit-right" }}>

                                                        <table className="">
                                                            {/* <tr style={{ textAlign: "end" }}>
                                                                <th className="gst-amounts">Total Qty</th>
                                                                <th className="gst-amounts3">
                                                                    {totalQty.toFixed(2) || 0.00}
                                                                </th>
                                                            </tr> */}
                                                            <tr style={{ textAlign: "end" }}>
                                                                <th className="gst-amounts">CGST Amt.</th>
                                                                <th className="gst-amounts3">  <i className="mdi mdi-currency-inr p-0"></i>
                                                                    {new Intl.NumberFormat('en-IN', {
                                                                        currency: 'INR',
                                                                        minimumFractionDigits: 2,
                                                                    }).format(totalCGSTAmount || 0)}
                                                                </th>
                                                            </tr>
                                                            <tr style={{ textAlign: "end" }}>
                                                                <th className="gst-amounts">SGST Amt.</th>
                                                                <th className="gst-amounts3">  <i className="mdi mdi-currency-inr p-0"></i>
                                                                    {new Intl.NumberFormat('en-IN', {
                                                                        currency: 'INR',
                                                                        minimumFractionDigits: 2,
                                                                    }).format(totalSGSTAmount || 0)}
                                                                </th>
                                                            </tr>
                                                            <tr style={{ textAlign: "end" }}>
                                                                <th className="gst-amounts">IGST Amt.</th>
                                                                <th className="gst-amounts3">  <i className="mdi mdi-currency-inr p-0"></i>
                                                                    {new Intl.NumberFormat('en-IN', {
                                                                        currency: 'INR',
                                                                        minimumFractionDigits: 2,
                                                                    }).format(totalIGSTAmount || 0)}

                                                                </th>
                                                            </tr>
                                                        </table>

                                                    </Col>
                                                    <Col md={5} style={{ fontSize: "14px", marginTop: "5px", textAlign: "-webkit-right" }} >
                                                        <table className="text-end" >

                                                            <tr style={{ textAlign: "end" }}>
                                                                <th className="gst-amounts">Taxable Amt.</th>
                                                                <th className="gst-amounts2">  <i className="mdi mdi-currency-inr p-0"></i>
                                                                    {new Intl.NumberFormat('en-IN', {
                                                                        currency: 'INR',
                                                                        minimumFractionDigits: 2,
                                                                    }).format(totalAmt || 0)}
                                                                </th>
                                                            </tr>
                                                            <tr style={{ textAlign: "end" }}>
                                                                <th className="gst-amounts">Taxes</th>
                                                                <th className="gst-amounts2">  <i className="mdi mdi-currency-inr p-0"></i>
                                                                    {new Intl.NumberFormat('en-IN', {
                                                                        currency: 'INR',
                                                                        minimumFractionDigits: 2,
                                                                    }).format(totalTexes || 0)}

                                                                </th>
                                                            </tr>
                                                            <tr style={{ textAlign: "end" }}>
                                                                <th className="gst-amounts">Discount</th>
                                                                <th className="gst-amounts2">  <i className="mdi mdi-currency-inr p-0"></i>
                                                                    {new Intl.NumberFormat('en-IN', {
                                                                        currency: 'INR',
                                                                        minimumFractionDigits: 2,
                                                                    }).format(discount || 0)}

                                                                </th>
                                                            </tr>
                                                            <tr style={{ textAlign: "end" }}>
                                                                <th className="gst-amounts">Net Amt.</th>
                                                                <th className="gst-amounts2">  <i className="mdi mdi-currency-inr p-0"></i>
                                                                    {/* {totalNetAmt} <br /> */}
                                                                    {new Intl.NumberFormat('en-IN', {
                                                                        currency: 'INR',
                                                                        minimumFractionDigits: 2,
                                                                    }).format(parseInt(totalNetAmt))}

                                                                </th>
                                                            </tr>
                                                        </table>

                                                    </Col>
                                                </Row>
                                            </Col>
                                        </Row>

                                        <Row>
                                            <div md={9} style={{ marginTop: "20px", alignItems: "center", display: "flex", gap: "15px" }} className="d-flex justify-content-end text-center">
                                                <div className="mt-3">
                                                    <div className=" d-flex gap-2">
                                                        <input
                                                            type="radio"
                                                            value="1"
                                                            id="cash"
                                                            name="mode"
                                                            className="form-check-input"
                                                            checked={paymentMethod === "1"}
                                                            // onChange={(e) => setpaymentMethod(e.target.checked ? "1" : "2")}
                                                            onClick={() => { setpaymentMethod("1") }}
                                                        />
                                                        <Label className="form-check-label font-size-13" htmlFor="cash">
                                                            Cash
                                                        </Label>

                                                        <input
                                                            type="radio"
                                                            value="2"
                                                            id="bank"
                                                            name="mode"
                                                            className="form-check-input"
                                                            checked={paymentMethod === "2"}
                                                            // onChange={(e) => setpaymentMethod(e.target.checked ? "2" : "1")}
                                                            onClick={() => { setpaymentMethod("2") }}
                                                        />
                                                        <Label className="form-check-label font-size-13" htmlFor="bank">
                                                            Bank
                                                        </Label>
                                                    </div>
                                                </div>
                                                <div className="" style={{ marginTop: "20px" }}>
                                                    <Button
                                                        color="secondary"
                                                        className="btn btn-primary me-2"
                                                        type="button"
                                                        onClick={() => {
                                                            {
                                                                navigate(routes.purchaseList)
                                                            }
                                                        }}
                                                    >
                                                        Cancel
                                                    </Button>
                                                </div>
                                                <div className="" style={{ marginTop: "20px" }}>

                                                    <Button
                                                        color="primary"
                                                        className="btn btn-primary me-2"
                                                        type="button"
                                                        onClick={e => {
                                                            e.preventDefault()
                                                            validation.handleSubmit()
                                                            return false
                                                        }}
                                                    >
                                                        Submit
                                                    </Button>
                                                </div>
                                            </div>

                                        </Row>
                                    </Form>

                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div >
        </React.Fragment >
    )
}

export default CreatePurchase
